import styled from 'styled-components';

export const Content = styled.div`
  /* position: absolute;
  right: 65px;
  top: -3px; */
  margin-right: 5px;
  width: 83px;
  label {
    color: #fff;
    display: block;
    font-size: 11px;
    line-height: 1;
    margin: 0 0 1px;
  }
  select {
    cursor: pointer;
    width: 100%;
    font-size: 11px;
    padding: 3px;
    /* background-color: '#4f5761';
    color: #ffffff; */
    /* height: 40px; */
    border-radius: 4px;
    border: solid 1px #bebebe;
    option {
      font-size: 11px;
    }
  }
`;
